import { z } from "zod";
import { staticText } from "../statics/static-text";

export const firstNameSchema = z
  .string()
  .min(1, staticText.inputs.firstName.validation.required);

export const lastNameSchema = z
  .string()
  .min(1, staticText.inputs.lastName.validation.required);

export const emailSchema = z
  .string()
  .min(1, staticText.inputs.email.validation.required)
  .email(staticText.inputs.email.validation.invalidEmail);

export const passwordSchema = z
  .string()
  .min(1, staticText.inputs.password.currentPassword.validation.rules.required);

export const newPasswordSchema = z
  .string()
  .min(1, staticText.inputs.password.newPassword.validation.rules.required)
  .min(8, staticText.inputs.password.newPassword.validation.rules.minimum)
  .regex(
    /[A-Z]/,
    staticText.inputs.password.newPassword.validation.rules.uppercase,
  )
  .regex(
    /[a-z]/,
    staticText.inputs.password.newPassword.validation.rules.lowercase,
  )
  .regex(
    /[^A-Za-z0-9]/,
    staticText.inputs.password.newPassword.validation.rules.digit,
  )
  .regex(
    /\d/,
    staticText.inputs.password.newPassword.validation.rules.specialCharacter,
  );

export const verificationCodeSchema = z
  .string()
  .min(1, staticText.inputs.verificationCode.validation.required)
  .regex(/^\d{6}$/, staticText.inputs.verificationCode.validation.sixDigits);
